<!-- =========================================================================================
  File Name: AttendeeList.vue
  Description: Attendee List
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Webspiders
  Author URL: https://www.webspiders.com
========================================================================================== -->
<style lang="scss">
.mail-btn {
  float: right;
  background: #869fb7;
  background-image: inherit !important;
}
.holamundo.customnewpopup .vs-popup {
  width: auto !important;
}
button.vs-component.vs-button.ml-3.setting-btn.vs-button-primary.vs-button-border {
  padding: 6px !important;
}
.setting-btn span img {
  height: 20px;
  width: 20px;
}
.file-up-section {
  text-align: center;
  border: 2px dashed #c8c8c8;
  margin-top: 15px;
  padding: 10px;
  border-radius: 5px;
}
.file-up-section p {
  color: #4c8af6;
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 5px;
}
.header-custome {
  margin-bottom: 15px;
}
</style>
<template>
  <div id="page-user-list">
    <!--<div class="header-custome">
      <h2>Page View Report</h2>
    </div>-->
    <div class="vx-card p-6">
      <div class="vx-row w-full">
        <div class="vx-col md:w-1/2 w-full mt-4">
          <label>
            <b>Page URL:&nbsp;</b>
          </label>
          <label>{{ PageName }}</label>
        </div>
        <!--<div class="vx-col md:w-1/2 w-full mt-4">
          <label>Type:&nbsp;</label>
          <label>{{ ActionType }}</label>
        </div>-->
      </div>
      <div class="flex flex-wrap items-center mt-4">
        <!-- ITEMS PER PAGE -->
        <div class="flex-grow">
          <vs-dropdown vs-trigger-click class="cursor-pointer">
            <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
            >
              <span
                class="mr-2"
              >{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ pageViewUserData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : pageViewUserData.length }} of {{ pageViewUserData.length }}</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>
            <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
            <vs-dropdown-menu>
              <!--<vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                <span>10</span>
              </vs-dropdown-item>-->
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                <span>20</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                <span>25</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                <span>30</span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="gridApi.paginationSetPageSize(100)">
                <span>100</span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>

        <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
        <vs-input
          class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
          v-model="searchQuery"
          @input="updateSearchQuery"
          placeholder="Search..."
        />
        <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
                   <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-42"
          >
            <span class="mr-2 leading-none" v-if="filtrDay == 0"><small>Filter : 24 hours</small></span>
            <span class="mr-2 leading-none" v-else-if="filtrDay > 0"><small>Filter : {{filtrDay}} days</small></span>
             <span class="mr-2 leading-none" v-else-if="filtrHours > 0"><small>Filter : {{filtrHours}} hours</small></span>
            <span class="mr-2 leading-none" v-else-if="filtrDay == -1"><small>Filter : All</small></span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
              <vs-dropdown-item @click="changeFilterByDays(6)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>6 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(12)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>12 Hours</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(24)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>24 Hours</span>
              </span>
            </vs-dropdown-item>
              <vs-dropdown-item @click="changeFilterByDays(3)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 3 days</span>
              </span>
            </vs-dropdown-item>
              <vs-dropdown-item @click="changeFilterByDays(7)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Last 7 days</span>
              </span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="changeFilterByDays(-1)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>All</span>
              </span>
            </vs-dropdown-item>

            <!--<vs-dropdown-item @click="changeStatus(false)">
              <span class="flex items-center">
                <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Set Inactive</span>
              </span>
            </vs-dropdown-item>-->
          </vs-dropdown-menu>
        </vs-dropdown>
        <!-- ACTION - DROPDOWN -->
        <vs-dropdown vs-trigger-click class="cursor-pointer ml-3">
          <div
            class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32"
          >
            <span class="mr-2 leading-none">Actions</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>

          <vs-dropdown-menu>
            <vs-dropdown-item @click="exportSelected()">
              <span class="flex items-center">
                <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                <span>Download CSV</span>
              </span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <!-- AgGrid Table -->
      <ag-grid-vue
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-full my-4 ag-grid-table"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="pageViewUserData"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :floatingFilter="true"
        :pagination="true"
        :paginationPageSize="paginationPageSize"
        :suppressPaginationPanel="true"
        :enableRtl="$vs.rtl"
      ></ag-grid-vue>

      <vs-pagination :total="totalPages" :max="7" v-model="currentPage" />
    </div>
  </div>
</template>
<script>
//import db from "@/firebase/firebaseInit.ts";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import "quill/dist/quill.snow.css";
import { quillEditor } from "vue-quill-editor";

// Store Module
import moduleAnalytics from "@/store/analytics/moduleAnalytics.js";
import ls from "@/common/localStorage";
import bu from "@/store/bulkupload/BulkUpload.js";

// Cell Renderer
import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererVerified from "./cell-renderer/CellRendererVerified.vue";
import CellRendererActions from "./cell-renderer/PageViewCellRendererActions.vue";

//console.log(db);
//const event_collectionName = 'sayek-dev';

var vm;
export default {
  components: {
    AgGridVue,
    vSelect,
    quillEditor,

    // Cell Renderer
    CellRendererLink,
    CellRendererStatus,
    CellRendererVerified,
    CellRendererActions
  },
  data() {
    return {
      filterModel: -1,
      filtrDay: null,
      filtrHours: null,
      settingsData: { ShowMeetingButton: false },
      popupActiveMail: false,
      popupActiveMailUpdate: false,
      mailRecepients: [],
      welcomeMailText: null,
      welcomeMailSubject: null,
      sourcehtml: null,
      // Filter Options
      roleFilter: { label: "All", value: "all" },
      roleOptions: [
        { label: "All", value: "all" },
        { label: "Admin", value: "admin" },
        { label: "User", value: "user" },
        { label: "Staff", value: "staff" }
      ],

      statusFilter: { label: "All", value: "all" },
      statusOptions: [
        { label: "All", value: "all" },
        { label: "Active", value: "active" },
        { label: "Deactivated", value: "deactivated" },
        { label: "Blocked", value: "blocked" }
      ],

      isVerifiedFilter: { label: "All", value: "all" },
      isVerifiedOptions: [
        { label: "All", value: "all" },
        { label: "Yes", value: "yes" },
        { label: "No", value: "no" }
      ],

      departmentFilter: { label: "All", value: "all" },
      departmentOptions: [
        { label: "All", value: "all" },
        { label: "Sales", value: "sales" },
        { label: "Development", value: "development" },
        { label: "Management", value: "management" }
      ],

      searchQuery: "",
      popupActive: false,
      popupActive2: false,
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      pageName: "",
      actionType: "",
      pageView_UserData: [],
      columnDefs: [
        //{
        //  //headerName: 'ID',
        //  field: "AttendeeId",
        //  //width: 40,
        //  filter: false,
        //  checkboxSelection: true,
        //  headerCheckboxSelectionFilteredOnly: true,
        //  headerCheckboxSelection: true
        //},
        //{
        //  headerName: "UID",
        //  field: "UID",
        //  filter: true,
        //  width: 200
        //},
          {
          //headerName: 'ID',
          //field: 'id',
          width: 50,
          checkboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
        },
        {
          headerName: "Name",
          field: "Uname",
          filter: true,
          width: 300
        },
        {
          headerName: "Email",
          field: "UserEmail",
          filter: true,
          width: 300
        },
        //{
        //  headerName: "Views",
        //  field: "Total",
        //  filter: true,
        //  width: 200
        //},
        //{
        //  headerName: "",
        //  field: "Total",
        //  filter: false,
        //  width: 200,
        //  cellRendererFramework: "CellRendererActions",
        //  cellRendererParams: params => {
        //    return {
        //      colName: "details",
        //      type: params.data.Type,
        //      uid: params.data.UID
        //    };
        //  }
        //},
        {
          headerName: "Total Views",
          field: "TotalViews",
          filter: false,
          width: 150,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: params => {
            return {
              colName: "user_view"
            };
          }
        },
        {
          headerName: "Total Actions",
          field: "TotalActions",
          filter: false,
          width: 200,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: params => {
            return {
              colName: "user_action"
            };
          }
        },
        {
          headerName: "View Details",
          field: "Total",
          filter: false,
          width: 200,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: params => {
            return {
              colName: "user_details",
              type: params.data.Type,
              uid: params.data.UID
            };
          }
        }
      ],

      // Cell Renderer Components
      components: {
        CellRendererLink,
        CellRendererStatus,
        CellRendererVerified,
        CellRendererActions
      }
    };
  },
  computed: {
    PageName() {
      return vm.pageName;
    },
    ActionType() {
      return vm.actionType;
    },
    pageViewUserData() {
      return this.pageView_UserData;
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 20;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage: {
      get() {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1;
        else return 1;
      },
      set(val) {
        this.gridApi.paginationGoToPage(val - 1);
      }
    }
  },
  methods: {
    fetch_user_data(page,filterDayOrhours) {
      this.$vs.loading();
      this.$store
        .dispatch("analytics/fetchPageViewUserData",{
          page :page,
          filterDayOrhours : filterDayOrhours
        })
        .then(res => {
          debugger;
          this.pageView_UserData = res.data;
            this.$vs.loading.close();
        })
        .catch(err => {
          //debugger;
          /*if (err.response.status === 404) {
            this.user_not_found = true;
            return;
          }*/
          this.$vs.loading.close();
          console.error(err);
        });
      //} else {
      //  this.$store
      //    .dispatch("analytics/fetchPageViewUserData", page)
      //    .then(res => {
      //      //debugger;
      //      this.pageView_UserData = res.data;
      //    })
      //    .catch(err => {
      //      //debugger;
      //      /*if (err.response.status === 404) {
      //      this.user_not_found = true;
      //      return;
      //    }*/
      //      console.error(err);
      //    });
      //}
    },
     exportSelected() {
      let selectedRows;
      selectedRows = this.gridApi.getSelectedRows();
      console.log(selectedRows);
      if (selectedRows.length > 0) {
        this.popupActiveExport = true;
        var datarow = [];

        datarow.push("Name");
        datarow.push("Email");
        datarow.push("Total Views");
        datarow.push("Total Actions");
        var engagementData = [];
        engagementData.push(datarow);

        selectedRows.map((row) => {
          //---------------------------------------------------------
          datarow = [];

          var name = row.Uname == undefined ? "" : row.Uname;
          datarow.push(name);
          var email = row.UserEmail == undefined ? "" : row.UserEmail;
          datarow.push(email);
          var totalViews = row.TotalViews == undefined ? "" : row.TotalViews;
          datarow.push(totalViews);
          var totalActions = row.TotalActions == undefined ? "" : row.TotalActions;
          datarow.push(totalActions);
          engagementData.push(datarow);
          //---------------------------------------------------------
        });
        debugger;
        let csvContent = "data:text/csv;charset=utf-8,";
        var dt = new Date().toISOString().slice(0, 10);
        engagementData.forEach(function (rowArray) {
          let row = rowArray.join(",");
          csvContent += row + "\r\n";
        });
        var filename = "EngagementData_"+this.pageName.slice(1)+ "_" + dt + ".csv";
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        //link.setAttribute("id", "Participance_RT_" + row.TableId);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click();
        //---------------------------------------------------------------
      } else {
        this.$vs.dialog({
          type: "alert",
          color: "warning",
          title: "Download Reports",
          text: "Please select atleast one engagement data to download. ",
          //accept: this.deleteRecord,
          acceptText: "OK",
        });
      }
    },
      changeFilterByDays(filterDayOrhours){
        if(filterDayOrhours == 6 || filterDayOrhours == 12 || filterDayOrhours == 24){
        this.filtrHours = filterDayOrhours;
        this.filtrDay = null;
      }else if(filterDayOrhours == -1){
        this.filtrDay = -1;
      }else{
          this.filtrDay = filterDayOrhours;
          this.filtrHours = null;
      }
      this.fetch_user_data(this.$route.params.page,filterDayOrhours)
    },
      updateSearchQuery(val) {
     this.gridApi.setQuickFilter(val);
    },
  },
  mounted() {
    //vm = this;
    this.gridApi = this.gridOptions.api;

    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
  },
  created() {
    vm = this;
    //debugger;
    if (this.$route.params.page == undefined) {
      this.$router.push({ name: "analytics-page-view" }).catch(() => {});
    } else {
      if (!moduleAnalytics.isRegistered) {
        this.$store.registerModule("analytics", moduleAnalytics);
        moduleAnalytics.isRegistered = true;
      }
      vm.pageName = this.$route.params.page;
    if(localStorage.getItem("Page_Engagement_dayOrHour") != null || localStorage.getItem("Page_Engagement_dayOrHour") != undefined){
          this.filtrDay = localStorage.getItem("Page_Engagement_dayOrHour");
          this.changeFilterByDays(localStorage.getItem("Page_Engagement_dayOrHour"))
    }else{
       this.filtrDay = -1;
       this.changeFilterByDays(-1)
    }
    }
  }
};
</script>

<style lang="scss">
#page-user-list {
  .user-list-filters {
    .vs__actions {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-58%);
    }
  }
}
</style>